<div class="container" style="margin-top: 20px;">
<h4 >{{configInput.heading}}</h4>
<form [formGroup]="configMaintainForm" (ngSubmit)="onSubmit()">
    <div class="row g-3">
        <div class="mb-3 col">
            <!-- <label for="ResultValue">{{configInput.key}}</label> -->
            <input type="text"  *ngIf="configInput.configType.toUpperCase() != 'ARRAY'" formControlName="ResultValue" class="form-control"  />
            <textarea *ngIf="configInput.configType.toUpperCase() == 'ARRAY'"  formControlName="ResultValue" class="form-control" cols=50 rows=40></textarea>
        </div>
</div>
<div class="mb-3">
    <button [disabled]="loading " class="btn btn-primary" >
        <span *ngIf="loading" class="spinner-border spinner-border-sm me-1"></span>
        Save
    </button>
</div>
</form>
</div>